'use strict';

const $ = window.jQuery;

export default function () {
    $('.expand-cookies-details').on('click', function () {
        $('.cookie-notice-params').niceScroll({
            cursorcolor: '#c99d66',
            cursorwidth: '3px',
            cursorborder: '0',
            cursorborderradius: '0'
        });
    });
};
